import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SubmitProviderInputsPayload } from '../../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { H1 } from '../../../../../../atoms/Heading/Heading';
import { Footer } from '../../../../../../atoms/Footer/Footer';
import { Button } from '../../../../../../atoms/Button/Button';
import { messages } from '../../messages';
import { ContentBody } from '../../../../../../atoms/ContentBody/ContentBody';

export type InstructionsViewProps = {
  title: string;
  handleSubmit: (values: SubmitProviderInputsPayload) => void;
};

export const InstructionsView: React.FC<InstructionsViewProps> = ({
  title,
  handleSubmit,
}: InstructionsViewProps) => {
  return (
    <ContentBody data-testid="InstructionsScreen">
      <H1>{title}</H1>
      <Footer stickToBottom px="none">
        <Button type="submit" color="primary" variant="contained" onClick={() => handleSubmit({})}>
          <FormattedMessage {...messages.submit} />
        </Button>
      </Footer>
    </ContentBody>
  );
};
